import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';

class AlertNameFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.ALERT_NAME;
    this.displayName = 'Alert Name';
    this.description = 'includes...';
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    return `Alert Name is ${
      filtersByOperatorObj[OperatorTypes.CONTAINS]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.CONTAINS]
          .map((filter) => filter.value1).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_CONTAIN]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_CONTAIN]
          .map((filter) => filter.value1).join(', ')
        };`
        : ''
    }`;
  }
}
export default AlertNameFacet;
